module.exports = __webpack_public_path__ + "img/38.c0076f26.svg";